import React from 'react';
import { TbTriangleInvertedFilled } from 'react-icons/tb';
import { FaEquals } from 'react-icons/fa';
import { TbTriangleFilled } from 'react-icons/tb';

const Details = ({ item }) => {
  const renderImage = () => {
    if (item?.percentage > 0) {
      return <TbTriangleFilled className="text-green-400" />;
    } else if (item?.percentage < 0) {
      return <TbTriangleInvertedFilled className="text-red-400" />;
    }
    return <FaEquals className="text-blue-300" />;
  };

  const renderColor = () => {
    if (item?.percentage > 0) {
      return 'bg-green-500 text-white rounded px-2 py-0.5';
    } else if (item?.percentage < 0) {
      return 'bg-red-500 text-white rounded px-2 py-0.5';
    }
    return 'bg-blue-500 text-white rounded px-2 py-0.5';
  };

  const formatPercent = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) {
      return value ?? '-';
    }
    return `${num.toFixed(2)}%`;
  };

  const formatDate = (value) => {
    if (!value) return '-';
    const raw = String(value).trim();
    const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const monthIdx = Number(match[2]) - 1;
      if (monthIdx >= 0 && monthIdx < 12) {
        return `${match[3]}-${monthNames[monthIdx]}-${match[1]}`;
      }
    }
    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) return raw;
    const day = String(parsed.getDate()).padStart(2, '0');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[parsed.getMonth()];
    const year = parsed.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="py-1.5">
      <div className="p-3 sm:p-4 flex flex-col gap-3 w-full bg-white text-black border border-gray-200 rounded-lg shadow-sm">
        <div className="flex justify-between items-start gap-3">
          <span className="text-sm sm:text-base font-semibold text-gray-900 leading-tight break-words">{item?.scripName || '-'}</span>
          <span className="inline-flex items-center gap-1 text-sm font-semibold shrink-0">
            {renderImage()}
            <span className={renderColor()}>{formatPercent(item?.percentage)}</span>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
          <div className="bg-gray-50 rounded-md px-2 py-1.5">
            <p className="text-xs uppercase tracking-wide text-gray-500">Inception Date</p>
            <p className="text-gray-800 font-medium">{formatDate(item?.inceptionDate)}</p>
          </div>
          <div className="bg-gray-50 rounded-md px-2 py-1.5">
            <p className="text-xs uppercase tracking-wide text-gray-500">Allocation</p>
            <p className="text-gray-800 font-medium">{item?.allocation ?? '-'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;